import { avatarColor, initials } from '../lib/format.ts'

type Props = {
  id: string
  name: string
  url?: string | null
  size?: number
  online?: boolean
}

export function Avatar({ id, name, url, size = 46, online }: Props) {
  const style = { width: size, height: size, fontSize: Math.round(size * 0.38) }

  return (
    <div className="avatar-wrap" style={{ width: size, height: size }}>
      {url ? (
        <img className="avatar" src={url} alt="" style={style} />
      ) : (
        <div className="avatar" style={{ ...style, ['--avatar-color' as string]: avatarColor(id) }}>
          {initials(name)}
        </div>
      )}
      {online && <span className="avatar-online" aria-label="в сети" />}
    </div>
  )
}
